// extracted by mini-css-extract-plugin
export default {"message_response":"AnswerForm_message_response__gAtVR","response":"AnswerForm_response__Ozjfv","file_name":"AnswerForm_file_name__MJUT-"};